<template>
  <div>
    <chart-card
      class="chart-order-container"
      :chartType="'bar'"
      :chartOptions="chartOptions"
      :chartData="chartData"
      :fromTo="fromTo"
      :title="title"
      :totalValue="`Tổng số đơn hàng: ${totalOrders}`"
      :subTitle="subTitleComputed"
      @acceptParams="acceptParams()"
    >
      <template #params-content> </template>
    </chart-card>
  </div>
</template>

<script>
import axios from "axios";
import ChartCard from "@/components/Cards/ChartCard";
import mixins from "@/mixins";
import moment from "moment/moment";

export default {
  mixins: [mixins],
  components: {
    ChartCard,
    // DateRangePicker,
  },
  data() {
    return {
      isShowChart: false,
      title: "Thống kê đơn hàng theo thời gian",
      fromTo: {},
      chartOptions: {
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            // borderRadius: 36,
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [],
          position: "bottom",
          labels: {
            rotate: 0,
            hideOverlappingLabels: true,
          },
          tickAmount: 5,
        },
        yaxis: {},
      },
      chartData: [
        {
          name: "Đơn hàng",
          data: [],
        },
      ],
      tableData: [],
      totalOrders: 0,
    };
  },
  mounted: function () {
    this.reloadChartDate();
  },
  computed: {},
  methods: {
    formatStringDate(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    acceptParams: function () {
      this.reloadChartDate();
    },
    reloadChartDate: function () {
      const fromDate = moment().startOf("month").format("YYYY-MM-DD"),
        toDate = moment().endOf("month").format("YYYY-MM-DD");
      this.fromTo.fromDate = moment().startOf("month").format("DD/MM");
      this.fromTo.toDate = moment().endOf("month").format("DD/MM");
      axios
        .get("c-report/count", {
          params: {
            fromDate,
            toDate,
          },
        })
        .then((res) => {
          let resultData = res.data;
          this.tableData = resultData.data.map((x) => {
            return {
              order_date: this.formatDate(x.order_date),
              count: x.count,
            };
          });
          if (resultData.data.length < 8) {
            this.chartOptions = {
              xaxis: {
                categories: resultData.data.map((x) =>
                  this.formatDate(x.order_date)
                ),
              },
            };
          } else {
            let temp = resultData.data.map((x) => {
              return resultData.data.indexOf(x) + 1;
            });
            this.chartOptions = {
              xaxis: {
                categories: temp,
              },
            };
          }
          this.chartData = [
            {
              data: resultData.data.map((x) => x.count),
            },
          ];
          this.totalOrders = resultData.data.reduce(
            (total, current) => total + +current.count,
            0
          );
        })
        .finally(() => {
          //   loader.hide();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.chart-order-container {
  position: static;
}
.mobile-report {
  margin: auto;
  th {
    height: 40px;
  }

  .count {
    border: 1px solid #cccccc;
    text-align: right;
    width: 100px;
    padding-right: 10px;
  }

  .order_date {
    border: 1px solid #cccccc;
    width: 180px;
    text-align: center;
  }

  tr {
    height: 30px;
  }

  tr:last-child {
    td {
      font-weight: bold;
    }
  }

  .total-text {
    text-align: center;
  }

  .total-value {
    text-align: right;
    padding-right: 10px;
  }
}
.drp-buttons {
  .cancelBtn {
    background-color: transparent;
    color: #000000;
    border: none;
  }
  .applyBtn {
    background-color: #1976d2;
    border-color: #1976d2;
    &:hover {
      background-color: #1976d2;
      border-color: #1976d2;
    }
  }
}

:deep(.total-container .total-item) {
  border: none;
}
</style>